import React from 'react';
import { ContainerTemplate } from '@/components';
import ApplicationCheckingV2Step from './ApplicationCheckingV2';

export { default as ApplicationChecking } from './ApplicationChecking';
export const ApplicationCheckingV2 = props => (
  <ContainerTemplate>
    <ApplicationCheckingV2Step {...props} />
  </ContainerTemplate>
);
